export default {
  black: '#000000',
  white: '#ffffff',

  primary: '#303f9f',

  blueGrey: '#607d8b',
  blueGrey_10: '#f0f4ff',
  blueGrey_50: '#eceff1',
  blueGrey_100: '#cfd8dc',

  grey: '#9e9e9e',
  grey_50: '#fafafa',
  grey_100: '#f5f5f5',
  grey_200: '#eeeeee',
  grey_300: '#e0e0e0',
  grey_400: '#bdbdbd',
};
